import { render } from "./InquiryDetails.vue?vue&type=template&id=1155b5db&scoped=true"
import script from "./InquiryDetails.vue?vue&type=script&lang=js"
export * from "./InquiryDetails.vue?vue&type=script&lang=js"

import "./InquiryDetails.vue?vue&type=style&index=0&id=1155b5db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1155b5db"]])

export default __exports__